const hasGeneralPermission = (user = {}, permissionsNeeded = []) => {
  if (!user?.permissions || !permissionsNeeded) {
    return false;
  }

  // const testMatch = user?.permissions?.some((stuff) => {
  //   return permissionsNeeded.includes(stuff);
  // });
  // console.log('testMatch:', testMatch);

  const stringPermissionMatch = user?.permissions?.some((userPermission) => {
    return permissionsNeeded.some((requirePermission) => {
      return userPermission.includes(requirePermission);
    });
  });

  function UserException(message) {
    this.message = message;
    this.name = 'UserException';
  }

  // if (!matchedPermissions?.length) {
  //   return false;
  //   // throw new Error(`You do not have sufficient permissions: ${permissionsNeeded}
  //   //   You Have: ${user.permissions}`);
  //   // throw new UserException(`You do not have sufficient permissions:
  //   //   You Need: ${permissionsNeeded}
  //   //   You Have: ${user.permissions}`);
  // }

  // return true;

  return stringPermissionMatch;
};

export { hasGeneralPermission as default };
